// extracted by mini-css-extract-plugin
export var divider = "_ie-7";
export var itemsToggle = "_ie-8";
export var mergeModal = "_ie-1";
export var optionCard = "_ie-4";
export var radioGroup = "_ie-6";
export var radioOption = "_ie-0";
export var selected = "_ie-5";
export var shipmentOptions = "_ie-2";
export var tableOptions = "_ie-3";